// Phase 18 Plan 03 — POLISH-08 useDocumentTitle hook.
//
// Sets `document.title` from an i18n message id resolved through react-intl.
// DEC-015 honored: no react-helmet dependency (Vite SPA = no SSR = no need
// for helmet's Provider tree; useEffect is enough).
//
// The hook re-runs whenever the resolved title string changes (i.e., when
// the locale flips en↔sv or the messageId changes). The intl instance
// itself is stable per <IntlProvider> render, so the dependency on the
// formatted string is sufficient and avoids re-running on every render.

import { useEffect } from 'react'
import { useIntl } from 'react-intl'

export function useDocumentTitle(
  messageId: string,
  values?: Record<string, string | number>,
): void {
  const intl = useIntl()
  const title = intl.formatMessage({ id: messageId }, values)
  useEffect(() => {
    document.title = title
  }, [title])
}
